import { render, staticRenderFns } from "./view-father.vue?vue&type=template&id=947bba56&scoped=true&"
import script from "./view-father.vue?vue&type=script&lang=js&"
export * from "./view-father.vue?vue&type=script&lang=js&"
import style0 from "./view-father.vue?vue&type=style&index=0&id=947bba56&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947bba56",
  null
  
)

export default component.exports